module.exports = __webpack_public_path__ + "img/notification.7c39f7c0.jpg";